/**
 * REV-949: the roles that may change a finding's status — confirm, false
 * positive, won't fix, resolve, reopen, and the bulk actions. Karl's decision
 * (2026-09-30): a viewer must not be able to set a finding's status.
 *
 * Mirrors revenant-api, where every triage write requires member or above
 * (feedbackService.assertCanTriage) and a viewer is refused with 403. The API
 * is the authority; this only decides what the UI offers.
 */
export const FINDING_TRIAGE_ROLES: readonly string[] = ['owner', 'admin', 'manager', 'member'];

/**
 * Whether `role` may change a finding's status. Fails closed: a role this list
 * does not know (a retired one, or none yet loaded) may not, as the API ranks
 * an unknown role below every known one.
 */
export const canTriageFindings = (role: string | null | undefined): boolean =>
  !!role && FINDING_TRIAGE_ROLES.includes(role);
